module.exports = __webpack_public_path__ + "img/0dfe6fd.png";